export const APP_URL = "https://app.violerts.com";
export const FEATURE_LINKS = [
    { to: "/reports", label: "Reports", blurb: "Property reports and Airtable sync" },
    { to: "/compliance", label: "Compliance", blurb: "Inspections, local laws and portfolio management" },
    { to: "/alerts", label: "Real-time Alerts", blurb: "Know when Violerts detects new or updated records" },
    { to: "/property-data", label: "Property Data", blurb: "Every office that can cite you" },
    { to: "/violation-resolution", label: "Violation Resolution", blurb: "A documented cure path per item" },
    { to: "/historical-data", label: "Historical Data", blurb: "Decades of property records" },
];
export const RESOURCE_LINKS = [
    { to: "/backend-search", label: "Backend search", blurb: "Query raw agency datasets" },
    { to: "/infra-code", label: "Infra code & API", blurb: "Pipelines, schemas and endpoints" },
    { to: "/blog", label: "Blog", blurb: "Regulatory changes and explainers" },
    { to: "/faqs", label: "FAQs", blurb: "Coverage, data lag and pricing" },
];
export const NAV_LINKS = [
    { to: "/about", label: "About" },
    { to: "/features", label: "Features", children: FEATURE_LINKS },
    { to: "/pricing", label: "Pricing" },
    { to: "/contact", label: "Contact" },
];
